import EspecialCardMenu from "../../../shared/components/especial_card_menu/especial_card_menu";
import ContactForm from "./contact_form";
import ContactWhatsapp from "./contact_whatsapp";

function SidebarInformation({ property }) {
  return (
    <div>
      <EspecialCardMenu title="Solicitar información">
        <ContactForm property={property} />
        <ContactWhatsapp property={property} />
      </EspecialCardMenu>
    </div>
  );
}

export default SidebarInformation;
